import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import { Dark } from '../../../../Theme/Theme'
import { FaCircleArrowUp, FaCircleArrowDown } from 'react-icons/fa6';

export default function Icon(props) {

  const socket = useContext(SocketContext);
  const symbol_id = props.symbol_id;

  const [change, setChange] = useState(0);
  const [lastLTP, setLastLTP] = useState(null);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data && data.LTP !== undefined && data.Previous_Close !== undefined) {
        const ltp = parseFloat(data.LTP);
        if (lastLTP !== ltp) {
          setLastLTP(ltp);
          setChange(ltp - parseFloat(data.Previous_Close));
        }
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id, lastLTP]);

  return (
    <div className="menuIcon">
      {change > 0 ? (
        <FaCircleArrowUp size={18} style={{ color: Dark.buy }} />
      ) : (
        <FaCircleArrowDown size={18} style={{ color: Dark.sell }} />
      )}
    </div>
  );
}
